module.exports = "/_next/static/images/a1682b9c17267ab47765516ff655c0b6-woman-with-iphone@0.5x.jpg.webp";